import React from "react";
import { RecoilRoot } from "recoil";
import Routes from "./routes";

const App = () => {
  return (
    <RecoilRoot>
      <Routes />
    </RecoilRoot>
  );
};

export default App;
